import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.97012 1.39667C7.38433 0.534443 8.61475 0.534445 9.02896 1.39667L10.8005 5.08446L14.8811 5.61875C15.8271 5.74262 16.221 6.91157 15.5166 7.57574L12.5347 10.3875L13.2831 14.4019C13.4607 15.355 12.4517 16.0615 11.6181 15.6121L7.99954 13.6613L4.381 15.6121C3.54737 16.0615 2.53834 15.355 2.71602 14.4019L3.46437 10.3875L0.482441 7.57574C-0.221931 6.91157 0.171979 5.74262 1.118 5.61875L5.19854 5.08446L6.97012 1.39667ZM7.99954 2.71786L6.46624 5.90963C6.29871 6.25836 5.9664 6.49672 5.58537 6.54661L2.06617 7.0074L4.63708 9.43156C4.91805 9.6965 5.04635 10.0863 4.97528 10.4676L4.32866 13.9362L7.45686 12.2498C7.79551 12.0672 8.20357 12.0672 8.54222 12.2498L11.6704 13.9362L11.0238 10.4676C10.9527 10.0863 11.081 9.6965 11.362 9.43156L13.9329 7.0074L10.4137 6.54661C10.0327 6.49672 9.70037 6.25835 9.53284 5.90963L7.99954 2.71786Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }